import React, { useEffect, useState } from 'react';
import _noop from 'lodash-es/noop';
import PropTypes from 'prop-types';
import DottedDropDown from '../../../components/DottedDropdown/DottedDropdown';
import DeleteProgramModal from '../DeleteProgramModal';
import { DottedActionBtnWrapper } from '../../common/styles';
import {
  applicableFlowTypes,
  currentFlowTypeEnum,
} from '../../common/components/constants';

const ActionProgramsTable = ({
  data,
  currentFlow,
  selectedWorkspace,
  getAllPrograms,
  viewOnlyMode,
  updatingProgramStatus,
  updateProgramStatusSuccess,
}) => {
  const options = [
    {
      label: 'Delete meal plan',
      value: 'delete_program',
      isActive: !viewOnlyMode,
    },
  ];

  const [selectedOption, setSelectedOption] = useState(null);
  const [
    isDeleteProgramModalVisible,
    setIsDeleteProgramModalVisible,
  ] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);

  const closeDeleteProgramModal = () => {
    setIsDeleteProgramModalVisible(false);
    setShouldRefresh(true);
  };

  useEffect(() => {
    if (updateProgramStatusSuccess && !updatingProgramStatus && shouldRefresh) {
      getAllPrograms({
        workspaceId: selectedWorkspace?.workspace_id ?? '',
        flowType: currentFlow,
      });
      setShouldRefresh(false);
    }
  }, [
    updateProgramStatusSuccess,
    updatingProgramStatus,
    shouldRefresh,
    getAllPrograms,
    selectedWorkspace,
    currentFlow,
  ]);

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption?.value) {
        case 'delete_program':
          setIsDeleteProgramModalVisible(true);
          break;
        default:
          console.log(data);
      }
      setSelectedOption(null);
    }
  }, [selectedOption, data]);

  return (
    <DottedActionBtnWrapper>
      <DottedDropDown options={options} setSelectedOption={setSelectedOption} />
      {isDeleteProgramModalVisible && !viewOnlyMode && (
        <DeleteProgramModal
          isVisible={isDeleteProgramModalVisible}
          closeModal={closeDeleteProgramModal}
          programData={data}
          currentFlow={currentFlow}
          selectedWorkspace={selectedWorkspace}
          getAllPrograms={getAllPrograms}
        />
      )}
    </DottedActionBtnWrapper>
  );
};

ActionProgramsTable.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  getAllPrograms: PropTypes.func,
  viewOnlyMode: PropTypes.bool,
  updatingProgramStatus: PropTypes.bool,
  updateProgramStatusSuccess: PropTypes.bool,
};

ActionProgramsTable.defaultProps = {
  data: {},
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_LIMIT,
  selectedWorkspace: {},
  getAllPrograms: _noop,
  viewOnlyMode: false,
  updatingProgramStatus: false,
  updateProgramStatusSuccess: false,
};

export default ActionProgramsTable;
